//@ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import InputForm, { AutoCompleteValue } from "../../../Components/InputForm/InputForm";
import ButtonForm from "../../../Components/ButtonForm/ButtonForm";
import { APICall } from "../../../Helpers/Network/APICalls";
// import {} from "../../../Helpers/APIEndPoints/EndPoints";
import { useLocation } from "react-router-dom";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import "./LocationMaster.css";
import { insertUpdateLocationData, getLocationDataById, CommonDropdownData } from "../../../Helpers/APIEndPoints/EndPoints";
import { useSelector } from "react-redux";
import moment from "moment";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";

const LocationMasterEdit = () => {
  const { state } = useLocation();
  let navigate = useNavigate();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [location, setLocation] = useState("");
  const [unitCode, setUnitCode] = useState({});
  const [unitCodeOption, setUnitCodeOption] = useState([]);
  const [code, setCode] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [formDataOnEdit, setFormDataOnEdit] = useState<any>({});
  // submit validation
  const [formErrors, setFormErrors] = useState({});
  const context = useSelector((state: any) => state.updateReduxStore);
  let formErrorObj = {};

  const selectOnChange = (event: any, apiFieldName: any) => {
    if (apiFieldName === "unitCode") {
      setUnitCode(event);
    }
  };

  const onSubmitValidation = () => {
    setFormErrors({});
    formErrorObj = {};
    if (!location || location === "") {
      formErrorObj["Location_isEmpty"] = "Location can not be empty";
    } else if (location.length > 100) {
      formErrorObj["Location_isEmpty"] = "Location name must be less than 100 characters";
    }
    if (!unitCode || Object.keys(unitCode).length <= 0) {
      formErrorObj["unitCode_isEmpty"] = "Please select unitCode";
    }
    if (!code || code === "") {
      formErrorObj["Code_isEmpty"] = "Code can not be empty";
    }
    setFormErrors(formErrorObj);
  };

  useEffect(() => {
    (async () => {
      showLoader();
      getDropDownDataApiCall();
      setEditMode(true);
      if (state !== null && state.id && state.id > 0) {
        await getLcationDataByIdF();
      }
      hideLoader();
    })();
  }, []);

  const getDropDownDataApiCall = async () => {
    showLoader();
    let requestParams = {
      dropdownName: "unitcodedd",
    };
    const res = await APICall(CommonDropdownData, requestParams);

    if (res && res.Data.length > 0) {
      let options = await res.Data;
      await setUnitCodeOption(options);
      hideLoader();
    } else {
      await setUnitCodeOption([]);
      notify(1, res.Message);
      hideLoader();
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };

  useEffect(() => {
    if (unitCodeOption.length > 0 && formDataOnEdit.UnitCodeId != "") {
      let val = unitCodeOption.find((ele) => ele.value == formDataOnEdit.UnitCodeId);
      setUnitCode(val);
    }
  }, [unitCodeOption, formDataOnEdit]);

  const getLcationDataByIdF = async () => {
    let obj = {
      Id: state.id,
    };
    const resp = await APICall(getLocationDataById, obj);
    if (resp?.Data?.Data?.length > 0) {
      setEditMode(false);
      setLocation(resp.Data.Data[0].Name);
      setCode(resp.Data.Data[0].Code);
      setIsActive(resp.Data.Data[0].IsActive);
      setFormDataOnEdit(resp.Data.Data[0]);
      // let values = {};
      // values = await resp.Data.Data.map((ele) => ({
      //   label: ele.unitcodevalue,
      //   value: ele.UnitCodeId,
      // }));
    }
  };

  const onClickFunction = async (action: any) => {
    showLoader();
    if (action === "Submit") {
      await onSubmitValidation();
      let isEmpty = Object.values(formErrorObj).every((f) => {
        return f === "" || f === null || f === undefined;
      });
      if (isEmpty === true) {
        let param = {
          Id: state.id != null || state.id != 0 ? state.id : 0,
          Name: location,
          Code: code,
          UnitCodeId: unitCode.value,
          IsActive: isActive ? 1 : 0,
          UserId: context.Id,
          CreatedBy: context.Id,
          CreatedDateUtc: moment(new Date()).format(moment.HTML5_FMT.DATETIME_LOCAL),
        };

        const insertData = await APICall(insertUpdateLocationData, param);

        if (insertData?.Data?.Status == ApiStatus.Error) {
          const errors = insertData?.Data?.Data;
          const errorComponent = Array.isArray(errors) ? <div dangerouslySetInnerHTML={{ __html: errors?.join("<br />") }} /> : errors;
          notify(1, errorComponent);
        } else if (insertData?.Status == ApiStatus.Error) {
          notify(1, insertData?.Data);
        } else if (insertData?.Data != null) {
          if (state !== null && state.id && state.id > 0) {
            notify(0, "Location successfully updated");
          } else {
            notify(0, "Location successfully inserted");
          }
          navigate(-1);
        }
      }
    } else if (action === "Reset") {
      resetFunction();
    } else if (action === "Cancel") {
      navigate(-1);
    }
    hideLoader();
  };

  const handleKeyNumbers = (event) => {
    // Prevent numeric character input
    const charCode = event.which || event.keyCode; // Handle cross-browser compatibility
    if (charCode >= 48 && charCode <= 57) {
      event.preventDefault();
    }
  };

  const handleTextEvent = async (event: any, field: any) => {
    let value = event.target.value;
    // const regex = /^[0-9]+$/;
    if (field === "location") {
      setLocation(value);
    }
    if (field === "code") {
      // if (value === "" || regex.test(value)) {
      if (value.length > 10) {
        value = value.slice(0, 10);
      }
      setCode(value);
      // }
    }
  };

  const resetFunction = () => {
    setFormErrors({});
    formErrorObj = {};
    setLocation("");
    setUnitCode({});
  };

  return (
    <>
      <div>
        <div className="">
          <div className="col-lg-12 col-md-12 p-0">
            <div className="row">
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
                <div className="form-group"></div>
                <label>Location</label>
                <sup style={{ fontSize: "13px" }}>*</sup>
                <InputForm
                  // disabled={editMode ? true : false}
                  placeholder={""}
                  value={location}
                  onChange={(e) => handleTextEvent(e, "location")}
                  textArea={false}
                  onKeyPress={handleKeyNumbers}
                />
                <p style={{ color: "red" }}>{formErrors["Location_isEmpty"]}</p>
              </div>
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
                <div className="form-group"></div>
                <label>Code</label>
                <sup style={{ fontSize: "13px" }}>*</sup>
                <InputForm
                  // disabled={editMode ? true : false}
                  placeholder={""}
                  value={code}
                  onChange={(e) => handleTextEvent(e, "code")}
                  onKeyPress={(e) => handleKeyPress(e)}
                  textArea={false}
                />
                <p style={{ color: "red" }}>{formErrors["Code_isEmpty"]}</p>
              </div>
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
                <div className="form-group"></div>
                <label>UnitCode</label>
                <sup style={{ fontSize: "13px" }}>*</sup>
                <SelectForm
                  options={unitCodeOption}
                  isMulti={false}
                  placeholder={""}
                  value={unitCode}
                  onChange={(event: any) => selectOnChange(event, "unitCode")}
                />
                <p style={{ color: "red" }}>{formErrors["unitCode_isEmpty"]}</p>
              </div>
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
              <div className="form-group"></div>
                <div className="form-group">
                  <label className="col-form-label">Active Status</label>
                  <sup>*</sup>
                  <div className="custom-checkbox">
                    <input
                      autoComplete={AutoCompleteValue}
                      disabled={editMode ? true : false}
                      type="checkbox"
                      onChange={(e) => setIsActive(e.target.checked)}
                      name="isActive"
                      checked={isActive}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end mt-3">
          <div>
            <ButtonForm className="btn btn-submit" style={{ marginLeft: 5 }} id="submit" value={<p><i className="fas fa-paper-plane"></i> Submit</p> } onClick={() => onClickFunction("Submit")} />
          </div>
          {state !== null && state.id && state.id > 0 ? (
            ""
          ) : (
            <div>
              <ButtonForm className="btn btn-info" id="Reset" style={{ marginLeft: 5 }} value={<p><i className="fas fa-undo"></i> Reset</p> } onClick={() => onClickFunction("Reset")} />
            </div>
          )}
          <div>
            <ButtonForm className="btn btn-cancel" id="cancel" style={{ marginLeft: 5 }} value={<p><i className="far fa-times-circle"></i> Cancel</p> } onClick={() => navigate("/master/LocationMaster")} />
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationMasterEdit;
